import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Box, CircularProgress, Container } from '@material-ui/core';
import {
  getTranslations,
  updateTranslations,
} from 'src/redux/settings/action';
import { useToast } from 'src/contexts/toast';
import TranslationsEditor from '../components/translations/TranslationsEditor';

const Translations = () => {
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const [rows, setRows] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const result = await dispatch(getTranslations());
      if (Array.isArray(result)) {
        const sorted = [...result].sort((a, b) =>
          (a.key || '').localeCompare(b.key || '')
        );
        setRows(sorted);
      } else {
        setRows([]);
      }
    } catch (err) {
      showToast(`Failed to load translations: ${err.message}`);
      setRows([]);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = async (payload) => {
    if (!payload || payload.length === 0) return;
    setSaving(true);
    try {
      await dispatch(updateTranslations(payload));
      showToast(
        `${payload.length} translation${payload.length === 1 ? '' : 's'} saved.`
      );
      await load();
    } catch (err) {
      showToast(`Save failed: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Washer - Translations</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ pt: 3 }}>
            {rows === null ? (
              <Box display="flex" justifyContent="center" py={6}>
                <CircularProgress />
              </Box>
            ) : (
              <TranslationsEditor
                rows={rows}
                onSave={handleSave}
                saving={saving}
              />
            )}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Translations;
